import { useState, useEffect } from "react";
import { Button, Form, Input, Select, Spin } from "antd";
import { useLocation, useNavigate } from "react-router";

import { GetUrlParams, ObjectNumbersToEnglish } from "scripts/helpers";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import Icons from "scripts/icons";
import { Link } from "react-router-dom";

const Component = () => {
	const initialState = { cities: [], id, provinces: [] };
	const [state, setState] = useState(initialState);
	const {
		cities,
		id,
		loaded,
		provinces,
		regDisable = true,
		submitting,
	} = state;
	const [form] = Form.useForm();
	const { search } = useLocation();
	const navigate = useNavigate();

	const handleCompare = (value) => {
		return !value || form.getFieldValue("password") === value
			? Promise.resolve()
			: Promise.reject(Resources.comparePass);
	};

	const handleCity = (id) => {
		API.cities(id, { paginate: false })
			.then(({ data: cities }) => {
				setState((prevState) => ({
					...prevState,
					loaded: true,
					cities: cities?.map(({ id, name }) => {
						return { label: name, value: id };
					}),
				}));
			})
			.catch({});
	};

	const handleTac = (e) => {
		if (e.target.checked) {
			setState((prevState) => ({
				...prevState,
				regDisable: false,
			}));
		} else {
			setState((prevState) => ({
				...prevState,
				regDisable: true,
			}));
		}
	};

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));
				delete values.tac;

				values = ObjectNumbersToEnglish(values);

				API.auth
					.register(values)
					.then(() => {
						navigate("/");
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidMount = () => {
		const params = GetUrlParams(search);
		form.setFieldValue("phone", params.mobile);

		API.provinces({ paginate: false })
			.then(({ data: provinces }) => {
				setState((prevState) => ({
					...prevState,
					loaded: true,
					provinces: provinces?.map(({ id, name }) => {
						return { label: name, value: id };
					}),
				}));
			})
			.catch({});
	};

	useEffect(componentDidMount, []);

	return (
		<>
			{loaded ? (
				<>
					<h1 className="heading">{`${Resources.register} ${Resources.at} ${Resources.bakelid}`}</h1>
					<span className="text">{Resources.loginText}</span>
					<Form form={form} layout="vertical" requiredMark={false}>
						<Form.Item
							name="phone"
							label={Resources.mobile}
							rules={Rules.mobile}
						>
							<Input
								readOnly
								type="tel"
								size="large"
								placeholder={Resources.mobile}
								prefix={<Icons.Calling />}
							/>
						</Form.Item>
						<Form.Item
							name="firstName"
							label={Resources.firstName}
							rules={Rules.required}
						>
							<Input
								type="text"
								size="large"
								placeholder={Resources.name}
								prefix={<Icons.Frame />}
							/>
						</Form.Item>
						<Form.Item
							name="lastName"
							label={Resources.lastName}
							rules={Rules.required}
						>
							<Input
								type="text"
								size="large"
								placeholder={Resources.lastName}
								prefix={<Icons.Frame />}
							/>
						</Form.Item>
						<Form.Item
							name="provinceId"
							label={Resources.province}
							rules={Rules.required}
						>
							<Select
								placeholder={Resources.province}
								options={provinces}
								optionFilterProp="label"
								onChange={(id) => handleCity(id)}
								showSearch
							/>
						</Form.Item>
						<Form.Item
							name="cityId"
							label={Resources.city}
							rules={Rules.required}
						>
							<Select
								placeholder={
									cities.length > 0
										? Resources.city
										: `${Resources.cityPlaceHolder}`
								}
								options={cities}
								optionFilterProp="label"
								showSearch
								disabled={!cities.length > 0}
							/>
						</Form.Item>
						<Form.Item
							name="password"
							label={Resources.password}
							rules={Rules.password}
						>
							<Input
								type="password"
								size="large"
								placeholder={Resources.password}
								prefix={<Icons.Lock />}
							/>
						</Form.Item>
						<Form.Item
							name="password_confirmation"
							label={`${Resources.confirm} ${Resources.password}`}
							rules={[
								...Rules.password,
								{
									validator: (rule, value) => handleCompare(value),
								},
							]}
						>
							<Input
								type="password"
								size="large"
								placeholder={`${Resources.confirm} ${Resources.password}`}
								prefix={<Icons.Lock />}
							/>
						</Form.Item>
					</Form>
					<div className="tac">
						<input type="checkbox" name="tac" onChange={(e) => handleTac(e)} />
						<label htmlFor="tac">
							{Resources.conditions}{" "}
							<Link to="/tac" target="_blank">
								{`${Resources.privacyPolicy} `}
							</Link>
							{Resources.iAgree}
						</label>
					</div>
					<div className="actions">
						<Button
							className="btn-default"
							size="large"
							loading={submitting}
							onClick={() => navigate("/auth/status", { replace: true })}
						>
							{`${Resources.edit} ${Resources.mobile}`}
						</Button>
						<Button
							type="primary"
							size="large"
							loading={submitting}
							onClick={handleSubmit}
							disabled={regDisable}
						>
							{Resources.register}
						</Button>
					</div>{" "}
				</>
			) : (
				<Spin className="page-loading" />
			)}
		</>
	);
};

export default Component;
